module.exports = __webpack_public_path__ + "img/previous.28ffc953.svg";